import React, { useState, Fragment } from 'react'
import PT from 'prop-types'

import { ActionMenuMobile, ActionMenuDesktop } from './OrderPartyActionMenu'

import OrderPartyLeaveConfirmation from './OrderPartyLeaveConfirmation'

import withNotifications from 'enhancers/withNotifications'

function OrderPartyAction({
  isMember = false,
  isLoggedIn = false,
  notify = () => {},
  onLeave = () => {},
  onRequestLogin = () => {},
  shareLink = '',
}) {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const [isLeavePending, setIsLeavePending] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const handleLeaveConfirmation = () => {
    if (!isLeavePending) {
      setIsOpen(false)
      setIsConfirmOpen(true)
    }
  }

  const handleLeavelCancel = () => {
    if (!isLeavePending) {
      setIsConfirmOpen(false)
    }
  }

  const handleCommitLeave = () => {
    setIsLeavePending(true)
    onLeave()
    setIsLeavePending(false)
    setIsConfirmOpen(false)
  }

  const handleShare = () => {
    notify({
      type: 'success',
      message: 'Copied to clipboard',
    })
    setIsOpen(false)
  }

  return (
    <Fragment>
      <ActionMenuMobile
        isOpen={isOpen}
        isLoggedIn={isLoggedIn}
        isMember={isMember}
        setIsOpen={setIsOpen}
        onShare={handleShare}
        onLeave={handleLeaveConfirmation}
        onRequestLogin={onRequestLogin}
        shareLink={shareLink}
      />
      <ActionMenuDesktop
        isOpen={isOpen}
        isLoggedIn={isLoggedIn}
        isMember={isMember}
        setIsOpen={setIsOpen}
        onShare={handleShare}
        onLeave={handleLeaveConfirmation}
        onRequestLogin={onRequestLogin}
        shareLink={shareLink}
      />
      <OrderPartyLeaveConfirmation
        onConfirm={handleCommitLeave}
        onCancel={handleLeavelCancel}
        isOpen={isConfirmOpen}
        isLoading={isLeavePending}
      />
    </Fragment>
  )
}

OrderPartyAction.propTypes = {
  notify: PT.func,
  onLeave: PT.func,
  shareLink: PT.string,
}

OrderPartyAction.defaultProps = {
  notify: () => {},
  onLeave: () => {},
  shareLink: 'Order party share link',
}

export default withNotifications(OrderPartyAction)
